"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpecialtyReact = exports.Specialty = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SpecialtyReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SpecialtyReact, _React$Component);
  var _super = _createSuper(SpecialtyReact);
  function SpecialtyReact() {
    var _this;
    (0, _classCallCheck2.default)(this, SpecialtyReact);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSpecialtiesDesktop", function () {
      var search = _this.props.search;
      return search.specialtyValues.map(function (val, index) {
        return _this.renderSpecialtyDesktop(val, index);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clickHandler", function (search, selection, event) {
      if (event) {
        event.persist();
      }
      var trigger = event ? event.key === 'Enter' ? true : false : true;
      if (trigger) {
        _this.props.updateSpecialtyState();
        _this.renderSpecialtyTab(search, selection);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSpecialtyDesktop", function (selection, ind) {
      var search = _this.props.search;
      var specialtyTabSelected = search.specialty;
      var tabNameVal = specialtyTabSelected === selection ? 'specialty-tab-selected' : 'specialty-tab';
      var contentNameVal = specialtyTabSelected === selection ? 'specialty-content-selected' : 'specialty-content';
      var tabStartVal = search.specialtyTabIndex ? search.specialtyTabIndex : 0;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: "specialty-fragment-".concat(ind)
      }, /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: "".concat(tabStartVal + ind),
        onClick: function onClick() {
          return _this.clickHandler(search, selection);
        },
        onKeyPress: function onKeyPress(e) {
          return _this.clickHandler(search, selection, e);
        },
        className: tabNameVal
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: contentNameVal
      }, selection)), /*#__PURE__*/_react.default.createElement("div", {
        className: "specialty-line"
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSpecialtyTab", function (search, selection) {
      if (search && selection) {
        _this.props.updateSearchField('specialty', selection);
        _this.props.updateSpecialtyState();
      }
      return /*#__PURE__*/_react.default.createElement("div", null);
    });
    return _this;
  }
  (0, _createClass2.default)(SpecialtyReact, [{
    key: "renderDropDownContents",
    value: function renderDropDownContents(searchState) {
      var _this2 = this;
      if (searchState && searchState.specialtyValues) {
        return searchState.specialtyValues.map(function (val, index) {
          return /*#__PURE__*/_react.default.createElement("div", {
            onClick: function onClick() {
              _this2.props.updateSearchField('specialty', val);
              _this2.props.updateSpecialtyState();
            },
            key: "specialty".concat(index)
          }, val);
        });
      }
      return /*#__PURE__*/_react.default.createElement("div", null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var search = this.props.search;
      var selectedVal = search.specialty ? search.specialty : 'Select';
      var enabledOrDisabled = selectedVal !== 'Select' ? 'enabled' : 'disabled';
      var classVal = search.specialtyOpen ? "select-selected ".concat(enabledOrDisabled) : "select-unselected ".concat(enabledOrDisabled);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "specialty"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "specialty-text"
      }, "Select a specialty"), /*#__PURE__*/_react.default.createElement("div", {
        className: "specialty-input-mobile"
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          return _this3.props.updateSpecialtyState();
        },
        className: classVal
      }, selectedVal), /*#__PURE__*/_react.default.createElement("div", {
        className: "select-items"
      }, this.renderDropDownContents(search))), /*#__PURE__*/_react.default.createElement("div", {
        className: "specialty-input-desktop"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "specialty-line"
      }), this.renderSpecialtiesDesktop()));
    }
  }]);
  return SpecialtyReact;
}(_react.default.Component);
exports.SpecialtyReact = SpecialtyReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    search: state.search,
    table: state.table,
    siteInfo: state.siteInfo
  };
};
SpecialtyReact.propTypes = {
  search: _propTypes.default.object,
  table: _propTypes.default.object,
  updateSearchField: _propTypes.default.func,
  updateSpecialtyState: _propTypes.default.func,
  renderSpecialtyTab: _propTypes.default.func,
  siteInfo: _propTypes.default.object.isRequired,
  specialtySelected: _propTypes.default.object
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Specialty = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SpecialtyReact);
exports.Specialty = Specialty;
